import React from 'react';
import styled from 'styled-components';
import { Card, Col, Container, Form, Row } from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';
import { primary } from '../theme/colors';
import Icon from './Icon';

const StyledCard = styled(Card)`
  border-color: #afb6b9;
`;

const FaqAndSupportBlock = () => {
  return (
    <div id="faq-and-support">
      <Container>
        <Row>
          <Col className="mb-1" lg={8}>
            <Icon colour={primary} icon="help" className="mb-2" />
            <h2>FAQ and Support</h2>
          </Col>
        </Row>
        <Row>
          <Col className="mb-3" lg={8}>
            <Form.Label>The Loop Knowledge Base</Form.Label>
            <StyledCard>
              <Card.Body>
                <ReactMarkdown>
                  Search here to find answers to many of our Frequently Asked
                  Questions and also some easy-to-follow self-help guides.
                </ReactMarkdown>
                <a
                  href="https://kb.loop.homes?utm_source=loop&utm_medium=webapp"
                  target="_blank"
                  rel="noreferrer">
                  Browse the Loop Knowledge Base
                </a>
              </Card.Body>
            </StyledCard>
          </Col>
        </Row>
        <Row>
          <Col className="mb-3" lg={8}>
            <Form.Label>The Loop Troubleshooting Tool</Form.Label>
            <StyledCard>
              <Card.Body>
                <ReactMarkdown>
                  Get troubleshooting help and support.
                </ReactMarkdown>
                <a
                  href="https://zingtree.com/show/440465166?utm_source=loop&utm_medium=webapp"
                  target="_blank"
                  rel="noreferrer">
                  Open the Loop Troubleshooting Tool
                </a>
              </Card.Body>
            </StyledCard>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default FaqAndSupportBlock;
